import type { MutationDef, MutationId } from './types';

export const MUTATION_CATALOG: Readonly<Record<MutationId, MutationDef>> = {
  // === COMMON (run-only) ===
  tough:       { id: 'tough',       rarity: 'common', persistence: 'run', delta: { maxHp: 20 } },
  sharp:       { id: 'sharp',       rarity: 'common', persistence: 'run', delta: { damage: 5 } },
  swift:       { id: 'swift',       rarity: 'common', persistence: 'run', delta: { speed: 20 } },
  quickHands:  { id: 'quickHands',  rarity: 'common', persistence: 'run', delta: { attackSpeed: 1.25 } },
  lucky:       { id: 'lucky',       rarity: 'common', persistence: 'run', delta: { critChance: 0.10 } },
  regen:       { id: 'regen',       rarity: 'common', persistence: 'run', passive: 'regen' },

  // === RARE (permanente para o bicho ativo) ===
  thornedHide: { id: 'thornedHide', rarity: 'rare', persistence: 'permanent', passive: 'thornedHide' },
  shield:      { id: 'shield',      rarity: 'rare', persistence: 'permanent', passive: 'shield' },
  burnTouch:   { id: 'burnTouch',   rarity: 'rare', persistence: 'permanent', passive: 'burnTouch' },
  iceTouch:    { id: 'iceTouch',    rarity: 'rare', persistence: 'permanent', passive: 'iceTouch' },
  lifesteal:   { id: 'lifesteal',   rarity: 'rare', persistence: 'permanent', passive: 'lifesteal' },
  doubleStrike: { id: 'doubleStrike', rarity: 'rare', persistence: 'permanent', passive: 'doubleStrike' },
  fortress:    { id: 'fortress',    rarity: 'rare', persistence: 'permanent', delta: { maxHp: 50, speed: -20 } },
  glassCannon: { id: 'glassCannon', rarity: 'rare', persistence: 'permanent', delta: { damage: 15, maxHp: -30 } },
  bloodlust:   { id: 'bloodlust',   rarity: 'rare', persistence: 'permanent', passive: 'bloodlust' },

  // === EPIC (heritável — vai pro genoma) ===
  phoenix:     { id: 'phoenix',     rarity: 'epic', persistence: 'heritable', passive: 'phoenix' },
  overload:    { id: 'overload',    rarity: 'epic', persistence: 'heritable', passive: 'overload' },
  aether:      { id: 'aether',      rarity: 'epic', persistence: 'heritable', passive: 'aether' },
};

export const ALL_MUTATIONS: ReadonlyArray<MutationDef> = Object.values(MUTATION_CATALOG);

export function commonMutations(): MutationDef[] { return ALL_MUTATIONS.filter((m) => m.rarity === 'common'); }
export function rareMutations(): MutationDef[] { return ALL_MUTATIONS.filter((m) => m.rarity === 'rare'); }
export function epicMutations(): MutationDef[] { return ALL_MUTATIONS.filter((m) => m.rarity === 'epic'); }
